import React from "react";
import { useState } from "react";
import { Select } from 'antd';
import Cookies from 'js-cookie';
import configData from "./config.json";

function Register() {
  const [values, setValues] = useState({ name: "", email: "", company: "", google_id: [], aniview_id: [], adkernel_id: [] });
  const [errors, setErrors] = useState({ name: "", email: "", company: "", google_id: "", aniview_id: "", adkernel_id: "", partner_id: "" });
  const [registrationStart, setRegistrationStart] = useState(false);
  // eslint-disable-next-line
  const [apiSuccessStatus, setApiSuccessStatus] = useState(false);
  const [apiSuccessMessage, setApiSuccessMessage] = useState('');
  // eslint-disable-next-line
  const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

  const doUserRegisterFirstStep = async function () {
    const errors = {};
    if (values.name === '') {
      errors.name = "Please enter your Full Name.";
      setRegistrationStart(false);
    }
    if (!isEmail(values.email)) {
      errors.email = "Please enter valid Email Address.";
      setRegistrationStart(false);
    }
    if (values.company === '') {
      errors.company = "Please enter Company Name.";
      setRegistrationStart(false);
    }
    setErrors(errors);

    if (!Object.keys(errors).length) {
      document.getElementById('partnerError').style.display='none';
      document.getElementById('details').style.display='none';
      document.getElementById('next').style.display='block';
    }
  };

  const doUserRegister = async function () {
    setApiSuccessMessage('');
    const errors = {};
    setRegistrationStart(true);
    
    document.getElementById('partnerError').style.display='none';
    if ((values.google_id.length < 1) && (values.aniview_id.length < 1) && (values.adkernel_id.length < 1)) {
      errors.partner_id = "Any one partner ID is needed";
      document.getElementById('partnerError').style.display='block';

      setRegistrationStart(false);
    }
    setErrors(errors);

    if (!Object.keys(errors).length) {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values, null, 2),
      };
      try {
        fetch(configData.SERVER_URL+"/register", requestOptions)
          .then(response => {
            return response.json()
          })
          .then(results => {
            if (results.success === true) {
              if (results.data.status === true) {
                setApiSuccessStatus(true);
                Cookies.set('registration_msg', results.message, { expires: 7 });
                window.location.href = "/";
              } else {
                setApiSuccessStatus(false);
                setApiSuccessMessage(results.message);
              }
              document.getElementById("registrationForm").reset();
            } else {
              setApiSuccessStatus(false);
              setApiSuccessMessage(results.message);
            }
            setRegistrationStart(false);
          }).catch(error=>{
            alert("There is some error in processing your request. Please try again in some time.");
          })
        return true;
      } catch (error) {
        setApiSuccessStatus(false);
        setApiSuccessMessage('Something went wrong. Please Try Again.');
        return false;
      }
    }
  };

  const checkEmail = () => {
    if (!isEmail(values.email)) {
      errors.email = "Please enter valid Email Address.";
    }else {
      errors.email = "";
    }
  }

  const handleChangeGoogleId = (value) => {
    document.getElementById('partnerError').style.display='none';
    errors.google_id = '';
    if(value) {
      setValues((values) => ({ ...values, google_id: value, }));
    }else {
      errors.google_id = 'gogole id is required.';
    }
  };

  const handleChangeAniviewId = (value) => {
    document.getElementById('partnerError').style.display='none';
    errors.aniview_id = '';
    if(value) {
      setValues((values) => ({ ...values, aniview_id: value, }));
    }else {
      errors.aniview_id = 'aniview id is required';
    }
  };

  const handleChangeAdkernelId = (value) => {
    document.getElementById('partnerError').style.display='none';
    errors.adkernel_id = '';
    if(value) {
      setValues((values) => ({ ...values, adkernel_id: value, }));
    }else {
      errors.adkernel_id = 'adkernal id si required';
    }
  };

  const previousTab = () => {
    document.getElementById('details').style.display='block';
    document.getElementById('next').style.display='none';
  }

  const keyDownHandler = event => {
    if (event.key === 'Enter') {
      console.log('Enter Key Pressed')
      event.preventDefault();
      doUserRegisterFirstStep();
    }
  }

  return (
    <>
    <style>
        {`
       :where(.css-dev-only-do-not-override-17a39f8).ant-select-dropdown{display:none !important}:where(.css-dev-only-do-not-override-1m62vyb).ant-select-dropdown{display:none}.ant-select.css-dev-only-do-not-override-1m62vyb.ant-select-multiple.ant-select-show-arrow.ant-select-show-search{border:1px solid #efefef;border-radius:0 .375rem .375rem 0;border-left:0!important}.ant-select-focused:where(.css-dev-only-do-not-override-1m62vyb).ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector{box-shadow:none!important;border-left:0!important;transition:none!important}.ant-select-show-search:where(.css-dev-only-do-not-override-1m62vyb).ant-select:not(.ant-select-customize-input) .ant-select-selector{cursor:text;height:100%!important;min-height:44px!important;padding-left:0!important;padding-top:5px!important;padding-bottom:5px!important}.ant-select-selector{background-image:none}.input-group:focus-within .ant-select.css-dev-only-do-not-override-1m62vyb.ant-select-multiple,.input-group.active .ant-select.css-dev-only-do-not-override-1m62vyb.ant-select-multiple,.input-group:focus-within .input-group-text{outline:0;transition:none;border-color:#1d8f83!important}.input-group-text{border-right:0!important}:where(.css-dev-only-do-not-override-1m62vyb).ant-select-multiple .ant-select-selection-item{border-radius:4px;border:1px solid #efefef!important;background:#fafafa!important;align-items:center}:where(.css-dev-only-do-not-override-1m62vyb).ant-select-multiple .ant-select-selection-item-content{color:#0a0a0a;font-size:14px;font-style:normal;font-weight:400;line-height:normal}
      `}
      </style>
    <div className="d-flex bg_main justify-content-between">
      <div className="login_content">
        <div className="login_text">
          <h2 className="login_heading">Harnessing Data to Drive Smarter Advertising Decisions.</h2>
          <p>Elevate Your Website's Ad Placement Strategy with<br /> Advanced Analytics.</p>
        </div>
        <div className="login_img">
          <img src="assets/media/images/login_img.svg" alt="login" />
        </div>
      </div>
      <div className="login_form d-flex align-items-center justify-content-center">
        <div className="login_form_inner">
          <div className="card_content">
            <form method="" id="registrationForm">
              <div className="h_15px mt-2 mb-4">
              {
                (apiSuccessMessage)
                ?
                <span className="error_head mt-2 mb-4">{apiSuccessMessage}</span>
                :
                ''
              }
              <span id="partnerError" style={{display: 'none'}} className="error_head text-start mt-2 mb-4"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" className="me-1">
                <path fillRule="evenodd" clipRule="evenodd" d="M2.40705 9.71838H9.59855C10.3895 9.71838 10.886 8.86337 10.493 8.17637L6.90005 1.89388C6.50455 1.20238 5.50755 1.20188 5.11155 1.89338L1.51255 8.17588C1.11955 8.86288 1.61555 9.71838 2.40705 9.71838Z" stroke="#ED0017" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.00098 6.20723V4.65723" stroke="#ED0017" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5.9975 7.75H6.0025" stroke="#ED0017" strokeLinecap="round" strokeLinejoin="round" />
              </svg> Any one partner ID is needed</span>
              </div>
              <div id="details" className="tabcontent">
                <div className="row">
                  <div className="form_group mb_40px">
                    <h5 className="sub_heading">Welcome! First things first...</h5>
                    <h1 className="heading mb-3">Setup Profile</h1>
                  </div>
                  <div className="col-md-12">
                    <div className="form_group mb_5px">
                      <label htmlFor="exampleFormControlInput1" className="form-label">Full Name</label>
                      <div className={(values.name) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                        <span className="input-group-text" id="addon-wrapping">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="stroke">
                            <path
                              d="M15 15.8333C15 13.9916 12.7617 12.4999 10 12.4999C7.23833 12.4999 5 13.9916 5 15.8333M10 9.99992C9.11594 9.99992 8.2681 9.64873 7.64298 9.02361C7.01786 8.39849 6.66667 7.55064 6.66667 6.66659C6.66667 5.78253 7.01786 4.93468 7.64298 4.30956C8.2681 3.68444 9.11594 3.33325 10 3.33325C10.8841 3.33325 11.7319 3.68444 12.357 4.30956C12.9821 4.93468 13.3333 5.78253 13.3333 6.66659C13.3333 7.55064 12.9821 8.39849 12.357 9.02361C11.7319 9.64873 10.8841 9.99992 10 9.99992Z"
                              strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>
                        <input type="text" className="form_control" placeholder="John Legend" aria-label="Username" onChange={(e) => setValues((values) => ({ ...values, name: e.target.value }))} value={values.name} onKeyDown={keyDownHandler} />
                      </div>
                      <span className="error">{(values.name) ? '' : errors.name}</span>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form_group mb_5px">
                      <label htmlFor="exampleFormControlInput1" className="form-label">Email Address</label>
                      <div className={(values.email) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                        <span className="input-group-text" id="addon-wrapping">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="fill">
                            <path
                              d="M10 17C9.04333 17 8.13917 16.8161 7.2875 16.4484C6.43583 16.0807 5.69197 15.579 5.0559 14.9434C4.4203 14.3078 3.91863 13.5642 3.5509 12.7125C3.18317 11.8608 2.99953 10.9567 3 10C3 9.03167 3.18387 8.12447 3.5516 7.2784C3.91933 6.43233 4.421 5.69173 5.0566 5.0566C5.6922 4.42053 6.4356 3.91887 7.2868 3.5516C8.138 3.18433 9.0424 3.00047 10 3C10.9683 3 11.8755 3.18387 12.7216 3.5516C13.5677 3.91933 14.3083 4.421 14.9434 5.0566C15.5795 5.6922 16.0811 6.43303 16.4484 7.2791C16.8157 8.12517 16.9995 9.03213 17 10V11.015C17 11.7033 16.7639 12.2897 16.2916 12.7741C15.8193 13.2585 15.2388 13.5005 14.55 13.5C14.13 13.5 13.7392 13.4067 13.3775 13.22C13.0158 13.0333 12.7183 12.7883 12.485 12.485C12.17 12.8 11.7995 13.048 11.3734 13.2291C10.9473 13.4102 10.4895 13.5005 10 13.5C9.03167 13.5 8.20613 13.1586 7.5234 12.4759C6.84067 11.7932 6.49953 10.9679 6.5 10C6.5 9.03167 6.84137 8.20613 7.5241 7.5234C8.20683 6.84067 9.03213 6.49953 10 6.5C10.9683 6.5 11.7939 6.84137 12.4766 7.5241C13.1593 8.20683 13.5005 9.03213 13.5 10V11.015C13.5 11.3533 13.605 11.6186 13.815 11.8109C14.025 12.0032 14.27 12.0995 14.55 12.1C14.83 12.1 15.075 12.0036 15.285 11.8109C15.495 11.6182 15.6 11.3529 15.6 11.015V10C15.6 8.47167 15.0486 7.15613 13.9459 6.0534C12.8432 4.95067 11.5279 4.39953 10 4.4C8.47167 4.4 7.15613 4.95137 6.0534 6.0541C4.95067 7.15683 4.39953 8.47213 4.4 10C4.4 11.5283 4.95137 12.8439 6.0541 13.9466C7.15683 15.0493 8.47213 15.6005 10 15.6H12.8C12.9983 15.6 13.1647 15.6672 13.2991 15.8016C13.4335 15.936 13.5005 16.1021 13.5 16.3C13.5 16.4983 13.4328 16.6647 13.2984 16.7991C13.164 16.9335 12.9979 17.0005 12.8 17H10ZM10 12.1C10.5833 12.1 11.0792 11.8958 11.4875 11.4875C11.8958 11.0792 12.1 10.5833 12.1 10C12.1 9.41667 11.8958 8.92083 11.4875 8.5125C11.0792 8.10417 10.5833 7.9 10 7.9C9.41667 7.9 8.92083 8.10417 8.5125 8.5125C8.10417 8.92083 7.9 9.41667 7.9 10C7.9 10.5833 8.10417 11.0792 8.5125 11.4875C8.92083 11.8958 9.41667 12.1 10 12.1Z" />
                          </svg>
                        </span>
                        <input type="email" className="form_control" placeholder="example@gmail.com" aria-label="UserID" onKeyUp={checkEmail} onChange={(e) => setValues((values) => ({ ...values, email: e.target.value }))} value={values.email} onKeyDown={keyDownHandler} />
                      </div>
                      <span className="error">{(values.email) ? ((errors.email === 'Please enter valid Email Address.') ? errors.email : '') : errors.email}</span>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form_group mb_5px">
                      <label htmlFor="exampleFormControlInput1" className="form-label">Company</label>
                      <div className={(values.company) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                        <span className="input-group-text" id="addon-wrapping">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="stroke">
                            <path
                              d="M15.4444 7H4.55556C3.69645 7 3 7.67157 3 8.5V14.5C3 15.3284 3.69645 16 4.55556 16H15.4444C16.3036 16 17 15.3284 17 14.5V8.5C17 7.67157 16.3036 7 15.4444 7Z"
                              stroke="#BDBDBD" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            <path
                              d="M8.33333 10.9999L8.50917 11.0883C8.97205 11.3197 9.48247 11.4402 10 11.4402C10.5175 11.4402 11.0279 11.3197 11.4908 11.0883L11.6667 10.9999M7.5 5.99992C7.5 5.55789 7.6756 5.13397 7.98816 4.82141C8.30072 4.50885 8.72464 4.33325 9.16667 4.33325H10.8333C11.2754 4.33325 11.6993 4.50885 12.0118 4.82141C12.3244 5.13397 12.5 5.55789 12.5 5.99992V6.83325H7.5V5.99992Z"
                              stroke="#BDBDBD" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>
                        <input type="text" className="form_control" placeholder="Facebook" aria-label="Company" onChange={(e) => setValues((values) => ({ ...values, company: e.target.value }))} value={values.company} onKeyDown={keyDownHandler} />
                      </div>
                      <span className="error mb-3">{(values.company) ? '' : errors.company}</span>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <button type="button" className="btn_primary w_100" onClick={() => doUserRegisterFirstStep()}><span className=" _text">NEXT</span></button>
                  </div>
                </div>
              </div>

              <div id="next" className="tabcontent" style={{ display: 'none' }}>
                <div className="row">
                  <div className="form_group mb_40px">
                    <h5 className="sub_heading ml_adjust">Awesome! Last final step.</h5>
                    <h1 className="heading mb-3">
                      <button type="button" className="btn-icon btn" onClick={previousTab}>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7 15H27C27.2652 15 27.5196 15.1054 27.7071 15.2929C27.8946 15.4804 28 15.7348 28 16C28 16.2652 27.8946 16.5196 27.7071 16.7071C27.5196 16.8946 27.2652 17 27 17H7C6.73478 17 6.48043 16.8946 6.29289 16.7071C6.10536 16.5196 6 16.2652 6 16C6 15.7348 6.10536 15.4804 6.29289 15.2929C6.48043 15.1054 6.73478 15 7 15Z" />
                          <path
                            d="M7.41383 16L15.7078 24.292C15.8956 24.4798 16.0011 24.7345 16.0011 25C16.0011 25.2656 15.8956 25.5203 15.7078 25.708C15.5201 25.8958 15.2654 26.0013 14.9998 26.0013C14.7343 26.0013 14.4796 25.8958 14.2918 25.708L5.29183 16.708C5.19871 16.6152 5.12482 16.5048 5.07441 16.3833C5.024 16.2618 4.99805 16.1316 4.99805 16C4.99805 15.8685 5.024 15.7383 5.07441 15.6168C5.12482 15.4953 5.19871 15.3849 5.29183 15.292L14.2918 6.29204C14.4796 6.10427 14.7343 5.99878 14.9998 5.99878C15.2654 5.99878 15.5201 6.10427 15.7078 6.29204C15.8956 6.47982 16.0011 6.73449 16.0011 7.00004C16.0011 7.26559 15.8956 7.52027 15.7078 7.70804L7.41383 16Z" />
                        </svg>
                      </button>Add Accounts
                      </h1>
                  </div>

                  <div className="col-md-12">
                    <div className="form_group mb_20px">
                      <label htmlFor="exampleFormControlInput1" className="form-label">Google ID</label>
                      <div className={(values.google_id.length > 0) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                        <span className="input-group-text" id="addon-wrapping">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect width="24" height="24" rx="4" fill="#E9F4FF" />
                            <path
                              d="M18.5372 10.6943H18.0002V10.6666H12.0002V13.3333H15.7678C15.2182 14.8856 13.7412 15.9999 12.0002 15.9999C9.79116 15.9999 8.00016 14.2089 8.00016 11.9999C8.00016 9.79092 9.79116 7.99992 12.0002 7.99992C13.0198 7.99992 13.9475 8.38458 14.6538 9.01292L16.5395 7.12725C15.3488 6.01759 13.7562 5.33325 12.0002 5.33325C8.3185 5.33325 5.3335 8.31825 5.3335 11.9999C5.3335 15.6816 8.3185 18.6666 12.0002 18.6666C15.6818 18.6666 18.6668 15.6816 18.6668 11.9999C18.6668 11.5529 18.6208 11.1166 18.5372 10.6943Z"
                              fill="#FFC107" />
                            <path
                              d="M6.10205 8.89692L8.29238 10.5033C8.88505 9.03592 10.3204 7.99992 12.0001 7.99992C13.0197 7.99992 13.9474 8.38459 14.6537 9.01292L16.5394 7.12725C15.3487 6.01759 13.7561 5.33325 12.0001 5.33325C9.43938 5.33325 7.21872 6.77892 6.10205 8.89692Z"
                              fill="#FF3D00" />
                            <path
                              d="M11.9999 18.6667C13.7219 18.6667 15.2866 18.0077 16.4696 16.936L14.4063 15.19C13.7145 15.7161 12.8691 16.0007 11.9999 16C10.2659 16 8.79361 14.8943 8.23894 13.3513L6.06494 15.0263C7.16827 17.1853 9.40894 18.6667 11.9999 18.6667Z"
                              fill="#4CAF50" />
                            <path
                              d="M18.537 10.6944H18V10.6667H12V13.3334H15.7677C15.5047 14.0722 15.0311 14.7178 14.4053 15.1904L14.4063 15.1897L16.4697 16.9357C16.3237 17.0684 18.6667 15.3334 18.6667 12.0001C18.6667 11.5531 18.6207 11.1167 18.537 10.6944Z"
                              fill="#1976D2" />
                          </svg>
                        </span>
                        <Select
                          mode="tags"
                          style={{ width: '100%' }}
                          onChange={handleChangeGoogleId}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form_group mb_20px">
                      <label htmlFor="exampleFormControlInput1" className="form-label">Aniview ID</label>
                      <div className={(values.aniview_id.length > 0) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                        <span className="input-group-text" id="addon-wrapping">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect width="24" height="24" rx="4" fill="#FFF1F2" />
                            <rect x="4" y="4" width="16" height="16" rx="8" fill="url(#pattern0)" />
                            <defs>
                              <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use href="#image0_10_90" transform="translate(-0.954545 -0.818182) scale(0.0113636)" />
                              </pattern>
                              <image id="image0_10_90" width="256" height="256" href="data:image/png;base64,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" />
                            </defs>
                          </svg>
                        </span>
                        <Select
                          mode="tags"
                          style={{ width: '100%' }}
                          onChange={handleChangeAniviewId}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form_group mb_27px">
                      <label htmlFor="exampleFormControlInput1" className="form-label">AdKernel ID</label>
                      <div className={(values.adkernel_id.length > 0) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}>
                        <span className="input-group-text" id="addon-wrapping">
                          <img src="assets/media/icons/AdKernel-ID.svg" className="svg-24px" alt="SVG" />
                        </span> 
                        <Select
                          mode="tags"
                          style={{ width: '100%' }}
                          onChange={handleChangeAdkernelId}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 text-end">
                    <button type="button" className={(registrationStart) ? 'btn_primary loading_btn' : 'btn_primary w-100'} onClick={() => doUserRegister()}>
                      {
                        (registrationStart)
                          ?
                          <>
                            <span className="loader_text hide">SIGNING UP <i className="fa fa-spinner fa-spin ms-1"></i></span>
                          </>
                          :
                          <>
                            <span className="btn_text">SIGN UP</span>
                          </>
                      }
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Register;